export default class NavMobile {
  constructor(container) {
    if (!container) return

    this.container = container
    this.panels = new Map()

    container.querySelectorAll('[data-panel-id]').forEach((panel) => {
      this.panels.set(panel.dataset.panelId, panel)
    })

    this.stack = ['root']

    this.onClick = this.onClick.bind(this)
    this.reset = this.reset.bind(this)

    container.addEventListener('click', this.onClick)
    this.updatePanels()
  }

  onClick(e) {
    const openTrigger = e.target.closest('[data-panel-target]')
    if (openTrigger) {
      e.preventDefault()
      this.openPanel(openTrigger.dataset.panelTarget)
      return
    }

    const backTrigger = e.target.closest('[data-panel-back]')
    if (backTrigger) {
      e.preventDefault()
      this.goBack()
    }
  }

  openPanel(panelId) {
    if (!this.panels.has(panelId)) return

    this.stack.push(panelId)
    this.updatePanels()
  }

  goBack() {
    if (this.stack.length <= 1) return

    this.stack.pop()
    this.updatePanels()
  }

  reset() {
    this.stack = ['root']
    this.updatePanels()
  }

  updatePanels() {
    const currentId = this.stack[this.stack.length - 1]
    const previousId = this.stack.length > 1 ? this.stack[this.stack.length - 2] : null

    this.panels.forEach((panel, id) => {
      panel.classList.remove('--active', '--previous')

      if (id === currentId) {
        panel.classList.add('--active')
      } else if (id === previousId) {
        panel.classList.add('--previous')
      }
    })
  }

  destroy() {
    this.container?.removeEventListener('click', this.onClick)
  }
}
